import { Field } from 'Util/Query';

/** @namespace Bodypwa/Util/Seo/QueryData/getSeoParams */
export const getSeoParams = () => [
    'meta_robots'
];

/** @namespace Bodypwa/Util/Seo/QueryData/getUrlData */
export const getUrlData = () => [
    'code',
    'url'
];
/** @namespace Bodypwa/Util/Seo/QueryData/getUrlWithIdData */
export const getUrlWithIdData = () => [
    'code',
    'url',
    'store_id'
];

/** @namespace Bodypwa/Util/Seo/QueryData/getRitchSnipetsData */
export const getRitchSnipetsData = (type = 'webpage', ...args) => [
    'seller',
    `${type}`,
    ...args,
    'website',
    'breadcrumbs',
    'organization'
];

/** @namespace Bodypwa/Util/Seo/QueryData/canonicalUrl */
export const canonicalUrl = (args = []) => {
    const [isPdp] = args;
    if (!isPdp) {
        return;
    }

    return new Field('mw_canonical_url')
        .addFieldList(getUrlData());
};
/** @namespace Bodypwa/Util/Seo/QueryData/items */
export const items = () => new Field('items')
    .addFieldList(getUrlWithIdData());

/** @namespace Bodypwa/Util/Seo/QueryData/hrefLang */
export const hrefLang = () => new Field('mw_hreflangs')
        .addField(items());

/** @namespace Bodypwa/Util/Seo/QueryData/ritchSnippets */
export const ritchSnippets = (type, ...args) => new Field('rich_snippets')
    .addFieldList(getRitchSnipetsData(type, ...args));

/** @namespace Bodypwa/Util/Seo/QueryData/seoMarkup */
export const seoMarkup = (type, ...args) => new Field('mw_seo_markup')
    .addField(ritchSnippets(type, ...args))
    .addField('social_markup');

/** @namespace Bodypwa/Util/Seo/QueryData/metaRobots */
export const metaRobots = () => new Field('meta_robots');
